import { useCallback } from "react";
import { DiscussionObjectTypeConstants } from "src/constants";

import { DiscussionVisibilityConstants } from "../../../../../constants/discussion/DicussionVisibilityConstants";
import {
  useDiscussionsBase,
  UseDiscussionsBaseResult,
} from "../../../../../widget/DiscussionsPanel/useDiscussionsBase";

export type UseDealDiscussionsResult = UseDiscussionsBaseResult;

export const useDealDiscussions = (dealUuid: string | undefined): UseDealDiscussionsResult => {
  const buildCreateRequest = useCallback(
    async (content: string, objectUuid: string, currentOrganisationUuid: string) => ({
      threadObjectType: DiscussionObjectTypeConstants.DEAL,
      threadObjectUuid: objectUuid,
      threadType: "Discussion" as const,
      visibility: DiscussionVisibilityConstants.INTERNAL,
      messageContent: content,
      messageType: "Comment" as const,
      messageObjectType: DiscussionObjectTypeConstants.DEAL,
      messageObjectUuid: objectUuid,
      messageStatus: "Published" as const,
      messageSourceOrganisationUuid: currentOrganisationUuid,
      messageTargetOrganisationUuids: null,
      componentKey: null,
      dataPath: null,
    }),
    []
  );

  return useDiscussionsBase({
    objectUuid: dealUuid,
    objectType: DiscussionObjectTypeConstants.DEAL,
    buildCreateRequest,
  });
};
